<template>
  <div class="component-content">
    <div class="ball-loading" v-if="loading">
      <div class="k-ball-holder3">
        <div class="k-ball7a"></div>
        <div class="k-ball7b"></div>
        <div class="k-ball7c"></div>
        <div class="k-ball7d"></div>
      </div>
    </div>
    <div class="card-room" v-else>
      <div class="no-list" v-if="paginationData.length < 1">
        <p>暂无与你相关的会议</p>
      </div>
      <div class="card-item" v-else v-for="item, i in paginationData">
        <div class="title">
          <div class="r">{{ item.status }}</div>
          <h3 class="name">{{ item.name }}</h3>
        </div>
        <div class="info">
          <!-- <p>{{item.depName}}</p> -->
          <user-info :userData='item.creator'></user-info>
          <p>会议时间：{{ item.conferenceTime }}</p>
          <p>会议地点：{{ item.depName + ' - ' + item.address }}</p>
          <p>会议要求：{{ item.req ? item.req : '无' }}</p>
          <p v-if="item.attachments">
            <span style="float:left;">会议资料：</span>
          <div class="conference">
            <p v-for="item, i in item.attachments">
              <a :href="item.fileUrl" target="_blank">{{ item.fileName }}</a>
            </p>
          </div>
          </p>
          <div class="user-list" v-html="getUserList(item.joinUsers)"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {
  mapState
} from "vuex";

import UserInfo from '@/components/UserInfo'
export default {
  components: {
    UserInfo,
  },
  computed: {
    ...mapState({
      organization: state => state.main.organization,
      userData: state => state.main.userData,
    })
  },
  data() {
    return {
      // 列表
      loading: true,
      pageSize: 2000,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],
    }
  },
  mounted() {
    this.getLists()

    // 我的会议消息清除
    this.msgRead()
  },
  methods: {

    // 我的会议消息清除
    msgRead() {
      ajax.get('/msg/conference/read', "", (res) => { })
    },

    getUserList(users) {
      let _item = ""
      for (var i = 0; i < users.length; i++) {
        _item += '<span class="user-item">' + users[i].name + '</span>'
      }
      return _item
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPaginationData()
    },
    // 搜索筛选新闻数据
    getFilterData() {
      console.log(this.filterName)
      if (this.filterName) {
        // 筛选出所有符合的数据
        this.filterData = []
        for (let i = 0; i < this.listData.length; i++) {
          let _new = this.listData[i]
          if (_new.name.indexOf(this.filterName) != -1) {
            this.filterData.push(_new)
          }
        }
      } else {
        this.filterData = this.listData
      }
      this.currentPage = 1
      this.getPaginationData()
    },
    // 分页筛选数据
    getPaginationData() {
      if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
        this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
      }
      if (this.currentPage == 0) {
        this.currentPage = 1
      }
      // 分页筛选
      this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
        .currentPage)
    },
    // 获取列表
    getLists() {
      ajax.get('/user/conference/list', { page: 0, pageSize: 100 }, (res) => {
        this.loading = false
        this.filterData = this.listData = res.vo.list
        this.getPaginationData()
      })
    },
  },
  watch: {

  }
};
</script>


// WEBPACK FOOTER //
// src/page/m/meetinglist.vue